import { makeAutoObservable } from "mobx";

interface IUsersPermissionsModel {
  permissions: string[];
}

class ApplicationUserRightsStore {
  permissions: string[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public IsAllowed(requiredPermissions: string[]): boolean {
    return requiredPermissions.every((v) => this.permissions.includes(v));
  }

  setData(data: IUsersPermissionsModel) {
    this.permissions = data.permissions;
  }
}

export const ApplicationUserRights = new ApplicationUserRightsStore();
